"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _ux = require("../../../ux");
const DonationTellAFriend = _ref => {
  let preview = _ref.preview,
    mobilization = _ref.mobilization,
    widget = _ref.widget,
    props = (0, _objectWithoutProperties2.default)(_ref, ["preview", "mobilization", "widget"]);
  return /*#__PURE__*/_react.default.createElement(_ux.TellAFriendBase, (0, _extends2.default)({
    preview: preview,
    mobilization: mobilization,
    widget: widget,
    message: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "donation.components--tell-a-friend.message",
      defaultMessage: "Oba, doa\xE7\xE3o registrada! Sua doa\xE7\xE3o \xE9 via boleto? Verifique seu email."
    })
  }, props));
};
var _default = exports.default = DonationTellAFriend;